import React from "react";
import "../App.css"; // assuming your styles are here

function ReserveButton({ children = "Réserver", onClick = () => { window.open('https://backoffice.bsport.io/m/IMPERIAL%20PILATES%20CLUB/4150/calendar/?isPreview=true', '_blank').focus(); } }) {
    return (
        <button className="reserve-button" onClick={onClick}>
            {children}
        </button>
    );
}

export default ReserveButton;